/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import { registerNetworkAPI } from 'wfui-digital-core/es/lib';
import get from './get';
import getJson from './get-json';
import fireAndForget from './fire-and-forget';
import postData from './post-data';
import postForm from './post-form';
import post from './post';
registerNetworkAPI({
  name: 'get',
  api: get
});
registerNetworkAPI({
  name: 'getJson',
  api: getJson
});
registerNetworkAPI({
  name: 'fireAndForget',
  api: fireAndForget
});
registerNetworkAPI({
  name: 'postData',
  api: postData
});
registerNetworkAPI({
  name: 'postForm',
  api: postForm
});
registerNetworkAPI({
  name: 'post',
  api: post
});